document.addEventListener('DOMContentLoaded', function () {
    // ===== MOBILE DRAWER SYSTEM =====
    const hamburgerBtn = document.querySelector('.hamburger-btn');
    const closeBtn = document.querySelector('.drawer-close-btn');
    const drawer = document.querySelector('.mobile-drawer');
    const overlay = document.querySelector('.mobile-drawer-overlay');

    function openDrawer() {
      const template = document.getElementById('MobileMenuTemplate');
      
      // If the template exists, inject it into the DOM on the first click
      if (template) {
        drawer.insertBefore(template.content.cloneNode(true), document.querySelector('.drawer-footer'));
        template.remove(); // Clean up the template tag
        
        // Bind the accordions now that they exist in the DOM
        const accordionToggles = document.querySelectorAll('.drawer-accordion-toggle');
        accordionToggles.forEach(function (toggle) {
          toggle.addEventListener('click', function () {
            const submenu = this.nextElementSibling;
            const isOpen = submenu.classList.contains('open');
            if (isOpen) {
              submenu.classList.remove('open');
              this.classList.remove('open');
            } else {
              submenu.classList.add('open');
              this.classList.add('open');
            }
          });
        });

        // Bind the close events to the new links
        const drawerLinks = document.querySelectorAll('.mobile-drawer a');
        drawerLinks.forEach(function (link) {
          link.addEventListener('click', function () {
            closeDrawer();
          });
        });
      }

      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (hamburgerBtn) hamburgerBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ===== CLOSE DRAWER ON LINK CLICK =====
    const drawerLinks = document.querySelectorAll('.mobile-drawer a');
    drawerLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        closeDrawer();
      });
    });

    // ===== ACCORDION FUNCTIONALITY LOGIC =====
    const accordionToggles = document.querySelectorAll('.drawer-accordion-toggle');

    accordionToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const submenu = this.nextElementSibling;
        const isOpen = submenu.classList.contains('open');

        if (isOpen) {
          submenu.classList.remove('open');
          this.classList.remove('open');
        } else {
          submenu.classList.add('open');
          this.classList.add('open');
        }
      });
    });

    // ===== WINDOW RESIZE RESET =====
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) {
        closeDrawer();
      }
    });

    // ===== DESKTOP HOVER MATRIX LOGIC =====
    let flyoutLeaveTimer;
    const shopFlyout = document.querySelector('.has-flyout');

    // 1. Add Grace Period Delay on Leave
    if (shopFlyout) {
      shopFlyout.addEventListener('mouseenter', function () {
        clearTimeout(flyoutLeaveTimer);
        this.classList.add('is-open'); // Tells Level 1 to open
      });

      shopFlyout.addEventListener('mouseleave', function () {
        flyoutLeaveTimer = setTimeout(function () {
          shopFlyout.classList.remove('is-open'); // Tells Level 1 to close after delay
          document.querySelectorAll('.flyout-panel.level-2, .flyout-panel.level-3').forEach(function (p) {
            p.classList.remove('active-panel');
          });
          document.querySelectorAll('.flyout-panel li').forEach(function (li) {
            li.classList.remove('active-item');
          });
        }, 500); // 500ms is perfect now that it controls the whole menu
      });
    }

    // 2. Level 1 -> Level 2 Logic
    const level1Items = document.querySelectorAll('.flyout-panel.level-1 > ul > li[data-cat]');
    level1Items.forEach(function (item) {
      const catName = item.getAttribute('data-cat');
      const targetPanel = document.querySelector('.flyout-panel.level-2[data-parent="' + catName + '"]');

      item.addEventListener('mouseenter', function () {
        clearTimeout(flyoutLeaveTimer);

        // Reset all level 1 items and hide all sub-panels
        document.querySelectorAll('.flyout-panel.level-1 > ul > li').forEach(function (li) {
          li.classList.remove('active-item');
        });
        document.querySelectorAll('.flyout-panel.level-2, .flyout-panel.level-3').forEach(function (p) {
          p.classList.remove('active-panel');
        });

        // Set current item to active
        item.classList.add('active-item');
        if (targetPanel) targetPanel.classList.add('active-panel');
      });
    });

    // 3. Level 2 -> Level 3 Logic
    const level2Panels = document.querySelectorAll('.flyout-panel.level-2');
    level2Panels.forEach(function (panel) {
      const subItems = panel.querySelectorAll('ul > li[data-subcat]');
      subItems.forEach(function (subItem) {
        const subcatName = subItem.getAttribute('data-subcat');
        const targetSubPanel = panel.querySelector('.flyout-panel.level-3[data-subparent="' + subcatName + '"]');

        subItem.addEventListener('mouseenter', function () {
          clearTimeout(flyoutLeaveTimer);

          // Reset sibling items and hide deeper panels
          panel.querySelectorAll('ul > li[data-subcat]').forEach(function (li) {
            li.classList.remove('active-item');
          });
          panel.querySelectorAll('.flyout-panel.level-3').forEach(function (p) {
            p.classList.remove('active-panel');
          });

          // Set current item to active
          subItem.classList.add('active-item');
          if (targetSubPanel) targetSubPanel.classList.add('active-panel');
        });
      });
    });

    // ===== SCROLL EVENT TRIGGER =====
    const desktopNav = document.querySelector('.custom-navbar');
    const mobileNav = document.querySelector('.mobile-navbar');

    function handleNavScrollShadow() {
      const scrolled = window.scrollY > 10;
      if (desktopNav) desktopNav.classList.toggle('scrolled', scrolled);
      if (mobileNav) mobileNav.classList.toggle('scrolled', scrolled);
    }

    window.addEventListener('scroll', handleNavScrollShadow);
    handleNavScrollShadow();

    // ===== PRESERVED CUSTOM CONNECTORS CLOSURE BLOCK =====
    // Please keep everything as it is, every single code as it is,
    // as there is a whole commented code which i will use in future.
    // That function is related to the connectors only
    // function initializeConnectors() { ... }

    // ===== STORE PREFETCH LIVE PREVIEW SEARCH =====
    const searchToggle = document.getElementById('nav-search-toggle');
    const mobileSearchToggle = document.getElementById('mobile-search-toggle');
    const searchOverlay = document.getElementById('nav-search-overlay');
    const searchClose = document.getElementById('nav-search-close');
    const searchInput = document.getElementById('nav-search-input');
    const searchResults = document.getElementById('nav-search-results');

    function openSearchOverlay() {
      if (searchOverlay) {
        searchOverlay.classList.add('active');
        setTimeout(function () {
          if (searchInput) searchInput.focus();
        }, 100);
      }
    }

    function closeSearchOverlay() {
      if (searchOverlay) {
        searchOverlay.classList.remove('active');
        if (searchInput) searchInput.value = '';
        if (searchResults) {
          searchResults.classList.remove('active');
          searchResults.innerHTML = '';
        }
      }
    }

    if (searchToggle) searchToggle.addEventListener('click', openSearchOverlay);
    if (mobileSearchToggle) mobileSearchToggle.addEventListener('click', openSearchOverlay);
    if (searchClose) searchClose.addEventListener('click', closeSearchOverlay);
    if (searchOverlay) {
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearchOverlay();
      });
    }

    let navSearchDebounce;
    function performNavSearch(query) {
      if (query.length < 2) {
        searchResults.classList.remove('active');
        searchResults.innerHTML = '';
        return;
      }

      searchResults.innerHTML = '<div class="nav-search-loading">Searching...</div>';
      searchResults.classList.add('active');

      fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor,tag'
      )
        .then((res) => res.json())
        .then((data) => {
          const products = data.resources.results.products;
          if (products.length === 0) {
            searchResults.innerHTML = '<div class="nav-search-no-results">No products found for "' + query + '"</div>';
            return;
          }

          let html = '';
          products.forEach((product) => {
            const image = product.image ? product.image : '';
            html +=
              '<a href="' +
              product.url +
              '" class="nav-search-result-item">' +
              (image
                ? '<img src="' + image + '" alt="' + product.title + '" class="nav-search-result-image">'
                : '<div class="nav-search-result-image"></div>') +
              '<div class="nav-search-result-info">' +
              '<p class="nav-search-result-title">' +
              product.title +
              '</p>' +
              '<p class="nav-search-result-price">' +
              product.price +
              '</p>' +
              '</div></a>';
          });

          html +=
            '<a href="/search?type=product&q=' +
            encodeURIComponent(query) +
            '" class="nav-search-view-all">View all results for "' +
            query +
            '"</a>';
          searchResults.innerHTML = html;
        })
        .catch(() => {
          searchResults.innerHTML = '<div class="nav-search-no-results">Error executing live query.</div>';
        });
    }

    if (searchInput) {
      let currentNavFocus = -1;

      searchInput.addEventListener('input', function () {
        clearTimeout(navSearchDebounce);
        const query = this.value.trim();
        navSearchDebounce = setTimeout(() => {
          currentNavFocus = -1; // Reset focus
          performNavSearch(query);
        }, 300);
      });

      searchInput.addEventListener('keydown', function (e) {
        const items = searchResults.querySelectorAll('.nav-search-result-item, .nav-search-view-all');

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          currentNavFocus++;
          addNavActive(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          currentNavFocus--;
          addNavActive(items);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (currentNavFocus > -1 && items.length > 0) {
            window.location.href = items[currentNavFocus].getAttribute('href');
          } else {
            const query = this.value.trim();
            if (query.length > 0) {
              window.location.href = '/search?type=product&q=' + encodeURIComponent(query);
            }
          }
        }
      });

      function addNavActive(items) {
        if (!items || items.length === 0) return;
        removeNavActive(items);
        if (currentNavFocus >= items.length) currentNavFocus = 0;
        if (currentNavFocus < 0) currentNavFocus = items.length - 1;
        items[currentNavFocus].classList.add('highlighted');
        items[currentNavFocus].scrollIntoView({ block: 'nearest' });
      }

      function removeNavActive(items) {
        items.forEach((item) => item.classList.remove('highlighted'));
      }
    }

    // ===== BROWSER BACK BUTTON FIX (BFCACHE) =====
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        fetch(window.location.pathname + '?section_id=cart-icon-bubble')
          .then((res) => res.text())
          .then((html) => {
            const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
            const targetElement = parsedDoc.querySelector('.shopify-section');
            const newHTML = targetElement ? targetElement.innerHTML : parsedDoc.body.innerHTML;

            const desktopCart = document.getElementById('cart-icon-bubble');
            const mobileCart = document.querySelector('.mobile-cart');

            if (desktopCart) desktopCart.innerHTML = newHTML;
            if (mobileCart) mobileCart.innerHTML = newHTML;
          });
      }
    });
  });